import { INSIDER_ID, INSIDER_URL } from 'core/constants/general.constants';
import { EInsiderPageType } from 'core/model/enums/insider.enum';
import type { IBusiness } from 'core/model/interfaces/business.interface';
import type { IUser } from 'core/model/interfaces/customer.interface';
import type { IOrderCreated } from 'core/model/interfaces/order.interface';
import type { ICartProduct, IProduct, IProductDetail } from 'core/model/interfaces/product.interface';
import { isLocalEnv } from './env.utils';
import {
  cartToInsiderCart,
  cutomerToInsiderUser,
  orderDetailToInsiderTransaction,
  productDetailToInsiderProduct,
  productListToInsiderProductList,
} from './insider.mapper';

export const initializeInsider = () => {
  const { Insider } = globalThis;

  if (Insider) {
    if (Insider.eventManager) {
      Insider.eventManager.dispatch?.('init-manager:re-initialize');
    } else {
      // eslint-disable-next-line no-console
      console.warn(`There is not eventManager in Insider`);
    }
  }

  // eslint-disable-next-line no-console
  else console.warn(`There is not Insider`);
};

export const settingInsiderPageType = (type: EInsiderPageType) => {
  globalThis.insider_object = {
    ...globalThis.insider_object,
    page: {
      type,
    },
  };

  if (isLocalEnv) {
    // eslint-disable-next-line no-console
    console.log(`Actualización del Page Object en Insider:`, globalThis.insider_object.page);
  }
};

export const cleanInsiderPageType = () => {
  globalThis.insider_object = {
    ...globalThis.insider_object,
    page: {},
  };
};

export const setInsiderUser = (customer: IUser, customerId: string, addresses: Array<IBusiness>) => {
  globalThis.insider_object = {
    user: cutomerToInsiderUser(customer, addresses),
  };
  globalThis.customer_id = customerId;
  localStorage.setItem('user_document_id', customer.basicData.document.number);

  if (isLocalEnv) {
    // eslint-disable-next-line no-console
    console.log('Actualización del User Object en Insider:', globalThis.insider_object.user);
  }
};

export const setInsiderProduct = (product: IProductDetail) => {
  globalThis.insider_object = {
    ...globalThis.insider_object,
    product: productDetailToInsiderProduct(product),
  };

  initializeInsider();

  if (isLocalEnv) {
    // eslint-disable-next-line no-console
    console.log('Actualización del Product Object en Insider:', globalThis.insider_object.product);
  }
};

export const setInsiderProductList = (products: Array<IProduct>) => {
  globalThis.insider_object = {
    ...globalThis.insider_object,
    listing: {
      items: productListToInsiderProductList(products),
    },
  };

  initializeInsider();

  if (isLocalEnv) {
    // eslint-disable-next-line no-console
    console.log('Actualización del Listing Object en Insider:', globalThis.insider_object.listing);
  }
};

export const setInsiderCart = (products: Array<ICartProduct>, currency: string, total: number) => {
  globalThis.insider_object = {
    ...globalThis.insider_object,
    basket: cartToInsiderCart(products, currency, total),
  };

  initializeInsider();

  if (isLocalEnv) {
    // eslint-disable-next-line no-console
    console.log('Actualización del Basket Object en Insider:', globalThis.insider_object.basket);
  }
};

export const setInsiderTransaction = (orders: Array<IOrderCreated>) => {
  globalThis.insider_object = {
    ...globalThis.insider_object,
    transaction: orderDetailToInsiderTransaction(orders),
  };

  initializeInsider();

  if (isLocalEnv) {
    // eslint-disable-next-line no-console
    console.log('Actualización del Transaction Object en Insider:', globalThis.insider_object.transaction);
  }
};

export const insertInsiderScript = (() => {
  let loader = false;
  return () => {
    if (!loader) {
      return new Promise(resolve => {
        loader = true;
        const url = `https://${INSIDER_URL}/ins.js?id=${INSIDER_ID}?v=${__APP_VERSION__}`;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = url;
        script.onload = () => {
          resolve(true);
        };

        script.onerror = () => {
          resolve(true);
        };
        document.body.appendChild(script);
      });
    }
  };
})();
